import IntroStoreBanner from './IntroStoreBanner';

export default IntroStoreBanner;
